<script>
import axios from "axios";

export default {
  methods: {
    getMelbTime() {
      let melbUTCOffset = 10;
      let currDate = new Date();
      let utc = currDate.getTime() + currDate.getTimezoneOffset() * 60000;
      let now = new Date(utc + 3600000 * melbUTCOffset);
      return this.parseDate(now, melbUTCOffset);
    },
    zfill(amount, val) {
      return val.toString().padStart(amount, "0");
    },
    parseDate(dateObj, utcOffset) {
      return `${dateObj.getFullYear()}-${this.zfill(
        2,
        dateObj.getMonth() + 1
      )}-${this.zfill(2, dateObj.getDate())} ${this.zfill(
        2,
        dateObj.getHours()
      )}:${this.zfill(2, dateObj.getMinutes())}:${this.zfill(
        2,
        dateObj.getSeconds()
      )}.${this.zfill(3, dateObj.getMilliseconds())}+${this.zfill(
        2,
        utcOffset
      )}:00`;
    },
    dollarPrice(priceStr) {
      if (priceStr || priceStr === 0) {
        return "$" + priceStr.toString();
      } else {
        return "";
      }
    },
    getUploadSource(uploadKind) {
      switch (uploadKind) {
        case "consent":
          return "otrsConsent";
        case "previousReport":
          return "otrsPreviousReport";
        default:
          // API endpoint "upload-service/v1/get-presigned-url"'s backend will throw type error if its value is not "otrsConsent" or "previousReport" or "dev"
          return "unknownKind";
      }
    },
    async getSignedS3UploadURL(file, uploadKind, orderId, uploadId) {
      try {
        const res = await axios.post(
          `${this.$dataset.uploadServiceApi}/v1/get-presigned-url`,
          {
            uploadSource: this.getUploadSource(uploadKind),
            expiresIn: 60 * 2, // 2 minutes.
            // uploadId prop is passed when there are multiple files uploaded for the same order e.g. 1
            fileName: file.name,
            fileType: "application/pdf",
            fileSize: file.size,
            extra: {
              orderId: orderId,
              uploadId: uploadId,
            },
          }
        );

        if (
          res.data.success &&
          res.data &&
          res.data.result &&
          res.data.result.signedS3UploadURL
        ) {
          return {
            success: true,
            signedS3UploadURL: res.data.result.signedS3UploadURL,
          };
        }

        return {
          success: false,
          errKind: "UPLOAD_URL_OBTAIN_ERROR",
          err: new Error("Unexpected response from backend!"),
        };
      } catch (err) {
        return {
          success: false,
          errKind: "UPLOAD_URL_OBTAIN_ERROR",
          err,
        };
      }
    },
    async uploadFileToS3(file, signedURL) {
      try {
        await axios({
          method: "put",
          url: signedURL,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        });

        return { success: true };
      } catch (err) {
        return {
          success: false,
          errKind: "UPLOAD_FILE_TO_S3_ERROR",
          err,
        };
      }
    },
  },
};
</script>
